import { useTranslation } from "react-i18next";
import { Spinner } from "../LoadingAnimations/LoadingAnimations";

const FormButtons = ({ onCancel, isLoading }) => {
  const { t } = useTranslation();
  return (
    <div className="full-cont">
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <button className="change-pwd-btn" type="submit">
            {t("buttons.submit")}
          </button>
          <button className="cancel-btn" type="button" onClick={onCancel}>
            {t("buttons.cancel")}
          </button>
        </>
      )}
    </div>
  );
};

export default FormButtons;